// import { PhoneNumberFormat as PNF, PhoneNumberUtil } from 'google-libphonenumber'
import moment from 'moment';

const DATE_FORMAT = 'MM/DD/YYYY';

const TIME_FORMAT = 'h:mm a'

const DATE_TIME_FORMAT = `${DATE_FORMAT} ${TIME_FORMAT}`;

const GENERATE_INPUT_OBJECT = (value = "", isValid = true, isRequired = true) => {
  return { value: value, isValid: isValid, isRequired: isRequired }
}

const isValidNumber = function(value){
  var pattern = new RegExp(/^[0-9]\d*(\.\d+)?$/)
  return pattern.test(value)
}
const isValidDate = function(dateString){
    // First check for the pattern
    if(!/^\d{1,2}\/\d{1,2}\/\d{4}$/.test(dateString))
        return false;

    // Parse the date parts to integers
    var parts = dateString.split("/");
    var day = parseInt(parts[1], 10);
    var month = parseInt(parts[0], 10);
    var year = parseInt(parts[2], 10);

    // Check the ranges of month and year
    if(year < 1000 || year > 3000 || month === 0 || month > 12)
        return false;

    var monthLength = [ 31, 28, 31, 30, 31, 30, 31, 31, 30, 31, 30, 31 ];

    // Adjust for leap years
    if(year % 400 === 0 || (year % 100 !== 0 && year % 4 === 0))
        monthLength[1] = 29;

    // Check the range of the day
    return day > 0 && day <= monthLength[month - 1];
};


const isValidEmail = function(value){
  var pattern = new RegExp(/^(([^<>()\]\\.,;:\s@"]+(\.[^<>()\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/);
  return pattern.test(value)
}


const isValidDob = function(date){
  return isValidDate(date) && moment(date, 'MM/DD/YYYY').isBetween('1890-01-01', moment().add(3, 'days'));
}

const isValidCollectionDate = function(date){
  return isValidDate(date) && moment(date, 'MM/DD/YYYY').isBetween(moment().subtract(30, 'days'), moment().add(30, 'days'));
}


//TODO Fix this function!
const isValidDateRange = function(startDate, endDate, toValidate){
  var format = 'MM/DD/YYYY'
  var date = toValidate ? startDate:endDate
  var isValid = !isValidDate(date);
  console.log(isValid)
  if(isValid){
    if(!toValidate){ //date being checked is start
      console.log("Checking START Date")
      if(!endDate){ //and no end date
        isValid = moment(startDate, format).isAfter(moment().startOf('day'));
        console.log(isValid ? "Valid date is after today":"Invalid start date is before today")
      } else { //has end date
        isValid = moment(startDate, format).isBetween(moment().startOf('day'), moment(endDate, format));
        console.log(isValid ? "Valid is between today and end date":"Invalid date is not between today and end Date")
      }
    } else { //date being checked is end of the range
      console.log("Checking END Date")
      if(startDate){//and has a start date
        isValid = moment(endDate, format).isAfter(moment(startDate, format));
      }
    }

  }
  return isValid
}

const isValidPhoneNumber = function(value){
  return true;
  // var phoneUtil = PhoneNumberUtil.getInstance();
  // var isValid;
  // try{
  //   isValid = phoneUtil.isValidNumber(phoneUtil.parse(value, 'US'))
  // } catch (e){
  //   return false;
  // }
  // return isValid;
}

const formatPhoneNumber = function(value){
  return value;
  // var phoneUtil = PhoneNumberUtil.getInstance();
  // return phoneUtil.format(phoneUtil.parse(value, 'US'), PNF.NATIONAL)
}

const phoneNumberMask = function(value){
  var x = value.replace(/\D/g, '').match(/(\d{0,3})(\d{0,3})(\d{0,4})/);
  return value = !x[2] ? x[1] : '(' + x[1] + ') ' + x[2] + (x[3] ? '-' + x[3] : '');
}

const dateMask = function(value){
  var x = value.replace(/\D/g, '').match(/(\d{0,2})(\d{0,2})(\d{0,4})/);
  return value = !x[2] ? x[1] : x[1]+ '/' + x[2] + (x[3] ? '/' + x[3] : '')
}

const isValidZip = function(value){
  return isValidNumber(value) && value.length === 5;
}

const states = [ { "name": "Alabama", "abbreviation": "AL" }, { "name": "Alaska", "abbreviation": "AK" }, { "name": "Arizona", "abbreviation": "AZ" }, { "name": "Arkansas", "abbreviation": "AR" }, { "name": "California", "abbreviation": "CA" }, { "name": "Colorado", "abbreviation": "CO" }, { "name": "Connecticut", "abbreviation": "CT" }, { "name": "Delaware", "abbreviation": "DE" }, { "name": "District Of Columbia", "abbreviation": "DC" }, { "name": "Florida", "abbreviation": "FL" }, { "name": "Georgia", "abbreviation": "GA" }, { "name": "Hawaii", "abbreviation": "HI" }, { "name": "Idaho", "abbreviation": "ID" }, { "name": "Illinois", "abbreviation": "IL" }, { "name": "Indiana", "abbreviation": "IN" }, { "name": "Iowa", "abbreviation": "IA" }, { "name": "Kansas", "abbreviation": "KS" }, { "name": "Kentucky", "abbreviation": "KY" }, { "name": "Louisiana", "abbreviation": "LA" }, { "name": "Maine", "abbreviation": "ME" }, { "name": "Maryland", "abbreviation": "MD" }, { "name": "Massachusetts", "abbreviation": "MA" }, { "name": "Michigan", "abbreviation": "MI" }, { "name": "Minnesota", "abbreviation": "MN" }, { "name": "Mississippi", "abbreviation": "MS" }, { "name": "Missouri", "abbreviation": "MO" }, { "name": "Montana", "abbreviation": "MT" }, { "name": "Nebraska", "abbreviation": "NE" }, { "name": "Nevada", "abbreviation": "NV" }, { "name": "New Hampshire", "abbreviation": "NH" }, { "name": "New Jersey", "abbreviation": "NJ" }, { "name": "New Mexico", "abbreviation": "NM" }, { "name": "New York", "abbreviation": "NY" }, { "name": "North Carolina", "abbreviation": "NC" }, { "name": "North Dakota", "abbreviation": "ND" }, { "name": "Ohio", "abbreviation": "OH" }, { "name": "Oklahoma", "abbreviation": "OK" }, { "name": "Oregon", "abbreviation": "OR" }, { "name": "Pennsylvania", "abbreviation": "PA" }, { "name": "Puerto Rico", "abbreviation": "PR" }, { "name": "Rhode Island", "abbreviation": "RI" }, { "name": "South Carolina", "abbreviation": "SC" }, { "name": "South Dakota", "abbreviation": "SD" }, { "name": "Tennessee", "abbreviation": "TN" }, { "name": "Texas", "abbreviation": "TX" }, { "name": "Utah", "abbreviation": "UT" }, { "name": "Vermont", "abbreviation": "VT" }, { "name": "Virginia", "abbreviation": "VA" }, { "name": "Washington", "abbreviation": "WA" }, { "name": "West Virginia", "abbreviation": "WV" }, { "name": "Wisconsin", "abbreviation": "WI" }, { "name": "Wyoming", "abbreviation": "WY" } ]

const dateRangesFuture = {
  'Today': [moment().startOf('day'), moment().endOf('day')],
  'Tomorrow': [moment().add(1, 'days').startOf('day'), moment().add(1, 'days').endOf('day')],
  'Next 7 Days': [moment(), moment().add(6, 'days')],
  'Next 30 Days': [moment(), moment().add(29, 'days')],
  'Next Month': [moment().add(1, 'month').startOf('month'), moment().add(1, 'month').endOf('month')],
  'Next Year': [moment().startOf('day'), moment().add(1, 'year').endOf('day')],
}

const dateRanges = {
  'Today': [moment().startOf('day'), moment().endOf('day')],
  'Yesterday': [moment().subtract(1, 'days').startOf('day'), moment().subtract(1, 'days').endOf('day')],
  'Last 7 Days': [moment().subtract(6, 'days'), moment()],
  'Last 30 Days': [moment().subtract(29, 'days'), moment()],
  'This Month': [moment().startOf('month'), moment().endOf('month')],
  'Last Month': [moment().subtract(1, 'month').startOf('month'), moment().subtract(1, 'month').endOf('month')],
}


export {
  DATE_FORMAT,
  TIME_FORMAT,
  DATE_TIME_FORMAT,
  GENERATE_INPUT_OBJECT,
  isValidNumber,
  isValidDate,
  isValidEmail,
  isValidDob,
  isValidCollectionDate,
  isValidDateRange,
  isValidPhoneNumber,
  formatPhoneNumber,
  phoneNumberMask,
  dateMask,
  isValidZip,
  states,
  dateRangesFuture,
  dateRanges,
}
